// extracted by mini-css-extract-plugin
export default {"ArrowButton":"ArrowButton_ArrowButton__xb+iT","ArrowContainer":"ArrowButton_ArrowContainer__T37AA","Plain":"ArrowButton_Plain__Pl3dY","Reverse":"ArrowButton_Reverse__SFEMu"};